import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GenericService } from '../common.service';
import { UtilityService } from '../utility.service';
@Injectable()
export class InstanceLevelPermissionService {
  constructor(private http: HttpClient, private oGenericService: GenericService, private __oUtilityService: UtilityService) {

  }
  AddToCollection(lDataEntityId, lDataInstanceId, existingCollection: any[] = null): any[] {
    if (existingCollection != null) {
      if (!this.__oUtilityService.IsNullOrUndefined(lDataEntityId) && !this.__oUtilityService.IsNullOrUndefined(lDataInstanceId)) {
        var existingData = existingCollection.find(x => x.DataEntityId === lDataEntityId);
        if (!this.__oUtilityService.IsNullOrUndefined(existingData)) {
          var existingInstanceData = existingData.DataInstanceIds.find(x => x === lDataInstanceId);
          if (this.__oUtilityService.IsNullOrUndefined(existingInstanceData)) {
            existingCollection.find(x => x.DataEntityId === lDataEntityId).DataInstanceIds.push(lDataInstanceId);
          }
          return existingCollection;
        }
      }
      else {
        return existingCollection;
      }
    }
    else {
      existingCollection = [];
    }
    if (!this.__oUtilityService.IsNullOrUndefined(lDataEntityId) && !this.__oUtilityService.IsNullOrUndefined(lDataInstanceId)) {
      let dataInstanceId: any = {};
      dataInstanceId.DataEntityId = lDataEntityId;
      dataInstanceId.DataInstanceIds = [];
      dataInstanceId.DataInstanceIds.push(lDataInstanceId);
      existingCollection.push(dataInstanceId);
    }
    return existingCollection;
  }
  CheckAccess(oInstanceLevelPermissionModel: any[]): Observable<any> {
    let body = JSON.stringify(oInstanceLevelPermissionModel);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    let uri = this.__oUtilityService.GetBasewebAPIURL() + 'api/InstanceLevelPermission/CheckSaveAccess';
    return this.http.post(uri, body, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {
        return throwError(this.handleError);
      })
    );
  }
  CheckNoAccess(oInstanceLevelPermissionModel: any[]): Observable<any> {
    let body = JSON.stringify(oInstanceLevelPermissionModel);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    let uri = this.__oUtilityService.GetBasewebAPIURL() + 'api/InstanceLevelPermission/CheckNoAccess';
    return this.http.post(uri, body, options).pipe(
      map((data: any) => {
        return JSON.parse(JSON.stringify(data));
      }),
      catchError((error) => {
        return throwError(this.handleError);
      })
    );
  }
  private handleError(error: any) {
    let errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(errMsg); // log to console instead
    return throwError(error);
  }
}
